module.exports = __webpack_public_path__ + "static/media/michael.fb9b3b1a.jpg";